import React from "react";
import * as R from "ramda";

export const getTableConfig = (tab) => {
    return tab === "NON_FOLLOW_UP"
    || tab === "ONGOING"
    || tab === "PENDING"
        ? tableConfig.withOverdue
        : tableConfig.withoutOverdue;
};

const tableConfig = {
    withOverdue: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "kodeCabang",
            label: "Kode Cabang",
        },
        {
            name: "overdue",
            label: "Overdue",
        },
        {
            name: "tanggalProspek",
            label: "Tanggal Prospek"
        },
        {
            name: "noProspek",
            label: "Nomor Prospek",
        },
        {
            name: "nama",
            label: "Nama",
        },
        {
            name: "nik",
            label: "NIK",
        },
        {
            name: "noHp",
            label: "No HP",
        },
        {
            name: "alamat",
            label: "Alamat",
        },
        {
            name: "provinsi",
            label: "Provinsi",
        },
        {
            name: "kabkot",
            label: "Kota/Kabupaten",
        },
        {
            name: "kecamatan",
            label: "Kecamatan",
        },
        {
            name: "kelurahan",
            label: "Kelurahan",
        },
        {
            name: "cabangAsal",
            label: "Cabang Asal",
        },
        {
            name: "penjualTerakhir",
            label: "Penjual Terakhir",
        },
        {
            name: "pemilikProspek",
            label: "Pemilik Prospek",
        },
        {
            name: "kategoriProspek",
            label: "Kategori Prospek",
        },
        {
            name: "jenisProspek",
            label: "Jenis Prospek",
        },
        {
            name: "asalProspek",
            label: "Asal Prospek",
        },
        {
            name: "lastFollowUpDate",
            label: "Last Follow Up Date",
        },
        {
            name: "lastFollowUpStatus",
            label: "Last Follow Up Status",
        },
        {
            name: "lastFollowUpBy",
            label: "Last Follow Up By",
        },
        {
            name: "nextAppointmentDate",
            label: "Next Appointment Date",
        },
        {
            name: "keterangan",
            label: "Keterangan",
        },
    ],
    withoutOverdue: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "kodeCabang",
            label: "Kode Cabang",
        },
        {
            name: "tanggalProspek",
            label: "Tanggal Prospek"
        },
        {
            name: "noProspek",
            label: "Nomor Prospek",
        },
        {
            name: "nama",
            label: "Nama",
        },
        {
            name: "nik",
            label: "NIK",
        },
        {
            name: "noHp",
            label: "No HP",
        },
        {
            name: "alamat",
            label: "Alamat",
        },
        {
            name: "provinsi",
            label: "Provinsi",
        },
        {
            name: "kabkot",
            label: "Kota/Kabupaten",
        },
        {
            name: "kecamatan",
            label: "Kecamatan",
        },
        {
            name: "kelurahan",
            label: "Kelurahan",
        },
        {
            name: "cabangAsal",
            label: "Cabang Asal",
        },
        {
            name: "penjualTerakhir",
            label: "Penjual Terakhir",
        },
        {
            name: "pemilikProspek",
            label: "Pemilik Prospek",
        },
        {
            name: "kategoriProspek",
            label: "Kategori Prospek",
        },
        {
            name: "jenisProspek",
            label: "Jenis Prospek",
        },
        {
            name: "asalProspek",
            label: "Asal Prospek",
        },
        {
            name: "lastFollowUpDate",
            label: "Last Follow Up Date",
        },
        {
            name: "lastFollowUpStatus",
            label: "Last Follow Up Status",
        },
        {
            name: "lastFollowUpBy",
            label: "Last Follow Up By",
        },
        {
            name: "nextAppointmentDate",
            label: "Next Appointment Date",
        },
        {
            name: "keterangan",
            label: "Keterangan",
        },
    ],
};

export const defaultFilter = {
    tanggalProspek: {
        tanggalAwal: null,
        tanggalAkhir: null
    },
    fuDate: {
        tanggalAwal: null,
        tanggalAkhir: null
    },
    appointmentDate: {
        tanggalAwal: null,
        tanggalAkhir: null
    },
    operator: null,
    comparator: null,
    overdue: null,
    prospectCategory: null,
    prospectKind: null,
    prospectSource: null,
    province: null,
    kabkot: null,
    kecamatan: null,
    kelurahan: null,
    kodePos: null,
    memberLevel: null,
    loyaltyLevel: null,
    facebook: null,
    instagram: null,
    linkedin: null,
    x: null,
    tiktok: null,
    hobby: [],
    interest: [],
    kodeCabang: null,
    prospectName: null,
    sourceCabang: null,
    ownerProspect: null,
    lastSeller: null,
    status: null,
    lastFollowUpBy: null,
    information: null,
    nama: null,
    nik: null,
    handPhoneNumber: null,
    handPhoneNumber2: null,
    alamat: null,
    lastFollowUpStatus:null,
    memberId:null,
};

export const extractFilter = (body) => {
    return {
        startNextAppointment: !R.isNil(body?.appointmentDate?.tanggalAwal) ? body?.appointmentDate?.tanggalAwal : null,
        endNextAppointment: !R.isNil(body?.appointmentDate?.tanggalAkhir) ? body?.appointmentDate?.tanggalAkhir : null,
        startLastDateFollowUp: !R.isNil(body?.fuDate?.tanggalAwal) ? body?.fuDate?.tanggalAwal : null,
        endLastDateFollowUP: !R.isNil(body?.fuDate?.tanggalAkhir) ? body?.fuDate?.tanggalAkhir : null,
        startDate: !R.isNil(body?.tanggalProspek?.tanggalAwal) ? body?.tanggalProspek?.tanggalAwal : !R.isNil(body?.startDate) ? body?.startDate : null,
        endDate: !R.isNil(body?.tanggalProspek?.tanggalAkhir) ? body?.tanggalProspek?.tanggalAkhir : !R.isNil(body?.endDate) ? body?.endDate : null,
        prospectCategory: !R.isEmpty(body?.prospectCategory) ? body.prospectCategory?.value : null,
        prospectKind: !R.isEmpty(body?.prospectKind) ? body.prospectKind?.value : null,
        prospectSource: !R.isEmpty(body?.prospectSource) ? body.prospectSource?.value : null,
        idProvince: !R.isNil(body?.idProvince) ? body.idProvince : null,
        idKabkot: !R.isNil(body?.idKabkot) ? body.idKabkot : null,
        kecamatan: !R.isNil(body?.kecamatan) ? body.kecamatan : null,
        kelurahan: !R.isNil(body?.kelurahan) ? body.kelurahan : null,
        kodePos: !R.isNil(body?.kodePos) ? body.kodePos : null,
        memberLevel: !R.isEmpty(body?.memberLevel) ? body.memberLevel?.value : null,
        loyaltyLevel: !R.isEmpty(body?.loyaltyLevel) ? body.loyaltyLevel?.value : null,
        facebook: !R.isEmpty(body?.facebook) ? body.facebook?.value : null,
        instagram: !R.isEmpty(body?.instagram) ? body.instagram?.value : null,
        linkedin: !R.isEmpty(body?.linkedin) ? body.linkedin?.value : null,
        x: !R.isEmpty(body?.x) ? body.x?.value : null,
        tiktok: !R.isEmpty(body?.tiktok) ? body.tiktok?.value : null,
        hobby: !R.isEmpty(body?.hobby) ? body?.hobby?.map(item => item.value) : null,
        interest: !R.isEmpty(body?.interest) ? body?.interest?.map(item => item.value) : null,
        kodeCabang: !R.isNil(body?.kodeCabang?.value) ? body.kodeCabang?.value : !R.isNil(body?.kodeCabang) ? body?.kodeCabang : null,
        prospectName: !R.isNil(body?.prospectName) ? body.prospectName : null,
        sourceCabang: !R.isNil(body?.sourceCabang) ? body.sourceCabang : null,
        ownerProspect: !R.isNil(body?.ownerProspect) ? body.ownerProspect : null,
        lastSeller: !R.isNil(body?.lastSeller) ? body.lastSeller : null,
        status: !R.isNil(body?.status) ? body.status : null,
        lastFollowUpBy: !R.isNil(body?.lastFollowUpBy) ? body.lastFollowUpBy : null,
        information: !R.isNil(body?.information) ? body.information : null,
        nama: !R.isNil(body?.nama) ? body.nama : null,
        nik: !R.isNil(body?.nik) ? body.nik : null,
        handPhoneNumber: !R.isNil(body?.handPhoneNumber) ? body.handPhoneNumber : null,
        alamat: !R.isNil(body?.alamat) ? body.alamat : null,
        comparator: !R.isEmpty(body?.operator) ? body?.operator?.value : null,
        overdue: !R.isNil(body?.operator) ? Number(body?.overdue||0) : null,
        memberId: !R.isNil(body?.memberId) ? body.memberId : null,
    }
}

export const notRequiredStatus = ["DROP", "DEATH"];

export const validateField = (values) => {
  const errors = {};

  Object.entries(values).forEach(([key, value]) => {
    if (
      key === "nextAppointmentDate" &&
      !notRequiredStatus.includes(values.followUpStatus.value)
    ) {
      if (value === null || value === undefined) {
        errors[key] = "Field belum diisi";
      } else if (
        typeof value === "object" &&
        value !== null &&
        "value" in value
      ) {
        if (
          value.value === null ||
          value.value === undefined ||
          value.value === ""
        ) {
          errors[key] = "Field belum diisi";
        } else {
          errors[key] = null;
        }
      } else {
        errors[key] = null;
      }
    }
  });

  return Object.keys(errors).some((key) => errors[key] !== null)
    ? errors
    : null;
};